import { MinusIcon, PlusIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export type RecordItemProps = {
  title?: string | null
  linked?: boolean
  onClick?: () => void
}

export function RecordItem (props: RecordItemProps) {
  const { title, linked, onClick } = props

  const { t } = useTranslation()

  return (
    <li
      className="menu-item cursor-pointer hover:bg-base-200"
      onClick={onClick}
    >
      <a className="flex items-center justify-between">
        <span className="truncate">
          {title || t('Unnamed')}
        </span>
        {linked ? <MinusIcon size={16} /> : <PlusIcon size={16} />}
      </a>
    </li>
  )
}
